import { TrashIcon } from '@heroicons/react/solid'
import router from 'next/router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { logout } from 'web/lib/supabase/auth'
import { ConfirmationButton } from '../buttons/confirmation-button'
import { Col } from '../layout/col'
import { Input } from '../widgets/input'
import { Title } from '../widgets/title'
import { api } from 'web/lib/api/api'

export function DeleteYourselfButton(props: { username: string }) {
  const { username } = props
  const { t } = useTranslation()

  const deleteAccount = async () => {
    await api('me/delete', { username })
    await logout()
  }

  const [deleteAccountConfirmation, setDeleteAccountConfirmation] = useState('')

  return (
    <ConfirmationButton
      openModalBtn={{
        className: 'p-2',
        label: t('deleteAccount.buttonLabel'),
        icon: <TrashIcon className="mr-1 h-5 w-5" />,
        color: 'red',
      }}
      submitBtn={{
        label: t('deleteAccount.submitLabel'),
        color:
          deleteAccountConfirmation == 'delete my account' ? 'red' : 'gray',
      }}
      onSubmitWithSuccess={async () => {
        if (deleteAccountConfirmation == 'delete my account') {
          toast
            .promise(deleteAccount(), {
              loading: t('deleteAccount.deleting'),
              success: () => {
                router.push('/')
                return t('deleteAccount.deleted')
              },
              error: () => {
                return t('deleteAccount.deleteFailed')
              },
            })
            .then(() => {
              return true
            })
            .catch(() => {
              return false
            })
        }
        return false
      }}
    >
      <Col>
        <Title>{t('deleteAccount.confirmTitle')}</Title>
        <div className="mb-2">
          {t('deleteAccount.warningPrimary')}
        </div>
        <div className="mb-6">
          {t('deleteAccount.warningSecondary')}
        </div>
        <Input
          type="text"
          placeholder={t('deleteAccount.confirmPlaceholder')}
          className="w-full"
          value={deleteAccountConfirmation}
          onChange={(e) => setDeleteAccountConfirmation(e.target.value)}
        />
      </Col>
    </ConfirmationButton>
  )
}
